import type { ReactNode } from "react";
import { StoreContext, type RootStore } from "./rootStore";

export function StoreProvider({ children, store }: { children: ReactNode; store: RootStore }) {
	return <StoreContext.Provider value={store}>{children}</StoreContext.Provider>;
}
